import React from "react";
import "./ScrollIcon.css";

/* SOURCE: https://codepen.io/2xsamurai/pen/WwmjKQ?js-preprocessor=none */

function ScrollIcon() {
	return (
		<div className="scroll-downs">
			<div className="mousey">
				<div className="scroller"></div>
			</div>
		</div>
	);
}

export default ScrollIcon;
